/* eslint-disable global-require */
import tools from '@/utils/tools';
import authStore from '@/store/auth';
import TIANQI_UBT from '@/utils/tianqiUBT';
import ParamsUtils from '@/utils/param';
import wechat from '@/utils/platformUtils/wechat';
import alipay from '@/utils/platformUtils/alipay';
import env from '../env.js';
import params from '../param';
// import Promise from 'pinkie-promise';
// eslint-disable-next-line import/no-cycle
import HewoxinCallNative from './HewoxinCallNative';


let timerId = null;
const readyPromise = new Promise((resolve, reject) => {
  if (env.isWeixin) {
    resolve('weixin');
  } else if (env.isEasyBikeApp || env.isHitchIndepApp) {
    if (env.isAndroid) {
      resolve('android app');
    } else if (env.isIOS && tools.versionCompare(env.appVersion, '3.1.4') >= 0) {
      resolve('ios app');
    }
    // 被app引用
    window.callJS = function callJS(data) {
      const { method } = data;
      if (method === 'web_view_finished_load') {
        // 旧版ios用uiwebview时调用
        resolve('ios app');
      } else {
        //
        throw new Error(`calljs method: ${method}没有实现`);
      }
    };
  } else {
    resolve('normal');
  }

  // 30000毫秒后置为reject
  setTimeout(() => {
    reject(new Error('网络状况较差,请重新进入'));
  }, 30000);
});

/**
 * 调用native方法，所有在native的方法在weixin和浏览器端都有相应实现
 */
function callNative(name, data, classMap) { // 'hideShareMenu', options, 'hideShare'
  return readyPromise
    .then(() => {
      if (env.isWeixin) {
        const WeixinCallNative = require('./WeixinCallNative.js').default;
        return WeixinCallNative.callNative(name, data);
      } if (env.isAlipayClient) {
        const AppCallNative = require('./AlipayCallNative.js').default;
        return AppCallNative.callNative(name, data);
      } if ((env.isEasyBikeApp || env.isHitchIndepApp) && window.AppFunctions) {
        // 被app引用
        const AppCallNative = require('./NewAppCallNative.js').default;
        return AppCallNative.callNative(classMap, name, data);
      } if ((env.isEasyBikeApp || env.isHitchIndepApp) && env.isIOS
        && tools.versionCompare(env.appVersion, '3.1.4') >= 0) {
        // 被ios ckwebview引用
        const AppCallNative = require('./NewAppCallNative.js').default;
        return AppCallNative.callNative(classMap, name, data);
      } if (env.isAliTrip) {
        const AppCallNative = require('./AliTripCallNative.js').default;
        return AppCallNative.callNative(name, data);
      } if (env.isUnionPay) {
        const AppCallNative = require('./UnionPayCallNative.js').default;
        return AppCallNative.callNative(name, data);
      } if (env.isRobotaxi) {
        const AppCallNative = require('./RobotaxiCallNative.js').default;
        return AppCallNative.callNative(name, data);
      } if (env.isTT) {
        const AppCallNative = require('./TTCallNative.js').default;
        return AppCallNative.callNative(name, data);
      }

      if (HewoxinCallNative.isHewoxin()) {
        return HewoxinCallNative.callNative(name, data);
      }

      // 被微信和普通浏览器正常引用
      const BrowserCallNative = require('./BrowserCallNative.js').default;
      return BrowserCallNative.callNative(name, data);
    });
}

export default class Native {
  static callNative(name, data) {
    callNative(name, data);
  }

  static setPageTitle({ title }) {
    return new Promise((resolve, reject) => {
      // 疑似在rouoter.afterEach中调用会阻塞页面切换，
      // 所以使用setTimeout处理
      if (timerId) {
        clearTimeout(timerId);
      }
      timerId = setTimeout(() => {
        callNative.apply(this, ['setPageTitle', { title }, 'NavBar'])
          .then(resolve, reject);
      });
    });
  }

  /**
   * 获取用户的token及key和ticket, 可用于引导用户进行登录
   * 如果needLogin为true, 且用户没有登录, 则会弹出登录窗口
   * @param needLogin 是否需要登录
   * @returns {*}
   */
  static getTokenAndKey({ needLogin = true } = { needLogin: true }) {
    return callNative.apply(this, [
      'getTokenAndKey', { needLogin }, 'User',
    ]).then((result) => {
      if (needLogin) {
        let isLogin = false;
        if (result.ticket) {
          isLogin = !!(result.token && result.ticket);
        } else {
          isLogin = !!(result.token);
        }
        if (!isLogin) {
          const { token, ticket } = authStore;
          if (token && ticket) {
            return { token, ticket };
          } if (token) {
            return { token };
          }
          throw new Error('用户未登录');
        }
      }
      return result;
    });
  }

  static jumpPOISearchPageToCreateStartAddress() {
    return callNative.apply(this, ['jumpPOISearchPageToCreateStartAddress', params, 'business/hitch']);
  }

  static jumpPOISearchPageToCreateEndAddress() {
    return callNative.apply(this, ['jumpPOISearchPageToCreateEndAddress', params, 'business/hitch']);
  }

  // 跳转鸿蒙原生页面
  static jumpTo(url) {
    const AppCallNative = require('./AlipayCallNative.js').default;
    AppCallNative.callNative('jumpTo', url);
  }

  static isLogin() {
    return Native.getTokenAndKey({ needLogin: false })
      .then((result) => {
        let isLogin = false;
        if (result.ticket) {
          isLogin = !!(result.token && result.ticket);
        } else {
          isLogin = !!(result.token);
        }
        return isLogin;
      });
  }

  static goBack() {
    return callNative.apply(this, ['goBack', null, 'NavBar']);
  }

  static closeWebView() {
    return callNative.apply(this, ['closeWebView', null, 'SystemUtil']);
  }

  static removeCurrentPage() {
    return callNative.apply(this, ['removeCurrentPage', null, 'business/hitch']);
  }

  /**
   * 清除登录信息
   */
  static invalidToken() {
    return callNative.apply(this, ['invalidToken', null, 'User']);
  }

  // static logout() {
  //   return callNative.apply(this, ['logout', null, 'User']);
  // }

  // 拨打电话
  static call(tel) {
    return callNative.apply(this, ['call', { tel }, 'SystemUtil']);
  }

  static makePhoneCall(tel) {
    return callNative.apply(this, ['makePhoneCall', { tel }, 'SystemUtil']);
  }

  static jumpToHome() {
    return callNative.apply(this, ['jumpToHome', null, 'SystemUtil']);
  }

  // ios用来判断支持哪些分享
  static getEnableShareChannel() {
    return callNative.apply(this, ['getEnableShareChannel', null, 'SystemUtil']);
  }

  // 启用分享 shareParty:[],1:微信好友, 2:微信朋友圈, 3:qq, 4:qq空间, 5:新浪微博, 6:二维码分享
  static initRightActionOrIcon(options) {
    // const { shareUrl: url = '' } = options.proData;
    return callNative.apply(this, ['initRightActionOrIcon', options, 'NavBar']);
  }

  static hideShareMenu(options) {
    return callNative.apply(this, ['hideShareMenu', options, 'hideShare']);
  }

  // 启用分享 shareParty:[],同上shareParty参数配置
  static initDirectShare(options) {
    // const { shareUrl: url = '' } = options;
    // options.shareUrl = url.replace(/m[\d\-a-z]+\.hellobike\.com/g, `${authStore.domain}`);
    return callNative.apply(this, ['initDirectShare', options, 'Share']);
  }

  // 分享type,1:微信，2:朋友圈, 3:qq 6：二维码分享
  static directItemShare(options) {
    // const { shareUrl: url = '' } = options;
    // options.shareUrl = url.replace(/m[\d\-a-z]+\.hellobike\.com/g, `${authStore.domain}`);
    return callNative.apply(this, ['directItemShare', options, 'Share']);
  }

  // 跳转到邀请好友列表页
  static goAppPage(options) {
    return callNative.apply(this, ['goAppPage', options, 'Business']);
  }

  static shareImage(options) {
    return callNative.apply(this, ['shareImage', options, 'Share']);
  }

  static getRideHistory(options) {
    return callNative.apply(this, ['getRideHistory', options, 'Business']);
  }

  static getDeviceInfo() {
    return callNative.apply(this, ['getDeviceInfo', null, 'SystemUtil']);
  }

  static showNativePayComponent(options) {
    return callNative.apply(this, ['showNativePayComponent', options, 'Pay']);
  }

  static showAppSuccessPage(options) {
    return callNative.apply(this, ['showAppSuccessPage', options, 'Business']);
  }

  // 重新加载页面
  static reload() {
    if (env.isAndroid && env.isWeixin) {
      const hash = +(new Date());
      let newSearch;
      if (/wechat_hash/.test(window.location.search)) {
        newSearch = window.location.search.replace(/wechat_hash=\d+(&?)/, `wechat_hash=${hash}$1`);
      } else {
        newSearch = window.location.search === ''
          // 如果 search 为空
          ? `?wechat_hash=${hash}`
          // 如果 search 不为空
          : `${window.location.search}&wechat_hash=${hash}`;
      }
      const newUri = window.location.origin
      + window.location.pathname + newSearch + window.location.hash;
      window.location.replace(newUri);
    } else {
      window.location.reload();
    }
  }

  static scanQRCode() {
    return callNative.apply(this, ['scanQRCode']);
  }

  /**
   * 振动设备
   */
  static vibrate(options) {
    return callNative.apply(this, ['vibrate', options]);
  }

  static getCurrentLocation() {
    return callNative.apply(this, ['getCurrentLocation']);
  }

  static async getCityInfo(needCustomEvent) {
    // 注意这里传入的是citycode跟adcode（全小写）
    const data = await callNative.apply(this, ['getCityInfo']);
    const getAdcode = data.adcode || data.adCode;
    const getCityCode = data.citycode || data.cityCode;
    const getCityName = data.city || data.cityName;
    if (needCustomEvent) {
      TIANQI_UBT.customEvent({
        eventId: 'Native_getCityInfo',
        data: JSON.stringify(data),
      });
    }
    if (!getAdcode || !getCityCode || !getCityName) {
      const adcode = params.get('adCode', window.location.href);
      const citycode = params.get('cityCode', window.location.href);
      const city = params.get('cityName', window.location.href);
      if (needCustomEvent) {
        TIANQI_UBT.customEvent({
          eventId: 'Native_getCityInfo_null',
          data: JSON.stringify({ adcode, citycode, city }),
        });
      }
      return {
        ...data, adcode, citycode, city,
      };
    }
    return data;
  }

  // 用于微信车主小程序常用路线找单列表
  static async getCityInfoV2() {
    return callNative.apply(this, ['getCityInfoV2']);
  }

  static chargeWallet(options) {
    return callNative.apply(this, ['chargeWallet', options]);
  }

  static chargeDeposit(options) {
    return callNative.apply(this, ['chargeDeposit', options]);
  }

  static chargeVip(options) {
    return callNative.apply(this, ['chargeVip', options]);
  }

  static getCurCityBikeType() {
    return callNative.apply(this, ['getCurCityBikeType']);
  }

  static setShareInfo(shareInfo) {
    return callNative.apply(this, ['setShareInfo', shareInfo]);
  }

  /**
   * 获取本地应用中用户的手机号
   */
  static getNativePhoneNo() {
    return callNative.apply(this, ['getNativePhoneNo']);
  }

  /**
   * 顺风车车主认证调用拍照
   */
  static callphotograph(options) {
    return callNative.apply(this, ['callphotograph', options]);
  }

  /**
  * 顺风车通过APP调用系统拍照及相册
  * @param Array {sourceType: [] } 默认 ['camera','album']
  * @description 5.37.0版本提供
  */
  static hitchCallCameraAndAlbum(options) {
    return callNative.apply(this, ['hitchCallCameraAndAlbum', options]);
  }

  /**
   * 调用APPd的OCR能力
   */
  static hitchGetOCRResult(options) {
    return callNative.apply(this, ['hitchGetOCRResult', options]);
  }

  static hitchSetWorkPath() {
    return callNative.apply(this, ['hitchSetWorkPath']);
  }

  /**
   * 返回promise，promise将在native api加载完成之后resolved
   * @return {Promise}
   */
  static ready() {
    return readyPromise;
  }

  /**
   * 保存图片到本地
   */
  static savePicture(options) {
    return callNative.apply(this, ['savePicture', options, 'SystemUtil']);
  }


  static getSSID() {
    return callNative.apply(this, ['getSSID']);
  }

  static sendEventLog(options) {
    return callNative.apply(this, ['sendEventLog', options]);
  }

  static gotoUserCertification(options) {
    return callNative.apply(this, ['gotoUserCertification', options]);
  }

  static getTaxiCreditRideGrantCode(options) {
    return callNative.apply(this, ['getTaxiCreditRideGrantCode', options]);
  }

  /**
   * 唤起活体识别
   * @param {string} options.idCardName
   * @param {string} options.idCardNumber
   * @param {string} options.idPlateNum 选填
   * @param {number} options.step 是车主申诉 7，账号找回 6
   */
  static openFaceLiveness(options) {
    return callNative.apply(this, ['openFaceLiveness', options]);
  }

  /**
   * 页面跳转
   * @param {sting} url跳转链接
   */
  static navigateTo(options) {
    return callNative.apply(this, ['navigateTo', options]);
  }

  /**
   * 重定向
   * @param {sting} url跳转链接
   */
  static redirectTo(options) {
    return callNative.apply(this, ['redirectTo', options]);
  }

  /**
   * * 页面跳转
   * @param {sting} url跳转链接
   * 因为平台universal link策略，m.hellobike.com域名将唤起App
   * 估在此处域名转化
   */
  static goLink(url) {
    const processedUrl = url.replace(/m\.hellobike\.com/g, 'm2.hellobike.com');
    return callNative.apply(this, ['navigateTo', processedUrl]);
  }

  /**
   * 唤起支付宝去实名认证
   *
   * @static
   * @param {*} options
   * @returns
   * @memberof Native
   */
  static gotoUserAliPayCertification(options) {
    return callNative.apply(this, ['gotoUserAliPayCertification', options]);
  }

  /**
   * 唤起支付宝去签署顺风车免密支付
   *
   * @static
   * @param {*} options
   * @returns
   * @memberof Native
   */
  static hitchOpenAliPayResult(options) {
    return callNative.apply(this, ['hitchOpenAliPayResult', options]);
  }

  /**
   * toast提示
   *
   * @static
   * @param {*} options
   * @returns
   * @memberof Native
   */
  static hitchToast(options) {
    return callNative.apply(this, ['hitchToast', options]);
  }

  /**
   * 打开微信服务通知
   */
  static openWechatNotice(options) {
    return callNative.apply(this, ['openWechatNotice', options]);
  }

  static openRecordStatusDetailPage(options) {
    return callNative.apply(this, ['openRecordStatusDetailPage', options, 'safeCenter']);
  }

  static hitchDriverPreCheckOrder(options) {
    return callNative.apply(this, ['hitchDriverPreCheckOrder', options, 'business/hitch']);
  }

  static hitchDriverFastRemindPassenger(options) {
    return callNative.apply(this, ['hitchDriverFastRemindPassenger', options, 'business/hitch']);
  }

  static platformOpenUrl(options) {
    return callNative.apply(this, ['platformOpenUrl', options, 'ui']);
  }

  static closeCancelReasonPageAndNavigateToChatVC(options) {
    return callNative.apply(this, ['closeCancelReasonPageAndNavigateToChatVC', options, 'business/hitch']);
  }

  /**
   * 唤起支付宝去签署顺风车免密支付
   *
   * @static
   * @param {*} options
   * @returns
   * @memberof Native
   */
  // 显示或者隐藏原生的topbar，参数isShow,boolean类型 5.12.0之后版本可用
  static showNaviBar(show) {
    return callNative.apply(this, ['showNaviBar', { isShow: show }, 'NavBar']);
  }

  // 显示或者隐藏顶部状态栏，参数isShowStatusBar:boolean,isDarkFont：boolean 5.15.0之后版本可用
  // 部分华为机有问题
  static setStatusBar({
    isShowStatusBar = true,
    isDarkFont = true,
  }) {
    return callNative.apply(this, ['setStatusBar', { isShowStatusBar, isDarkFont }, 'NavBar']);
  }

  /**
   * 修改顶部状态栏颜色字体颜色
   * @param {*} colorCode 状态栏颜色，字符串类型，传入格式：#ffffff，不传默认为白色
   * @param {*} isDarkFont 状态栏字体颜色，是否为黑色，非黑即白，boolean类型
   */
  // ，参数isShowStatusBar:boolean,isDarkFont：boolean 5.29.0之后版本可用
  static setStatusBarColor({
    colorCode = 'ffffff',
    isDarkFont = true,
  }) {
    return callNative.apply(this, ['setStatusBarColor', { colorCode, isDarkFont }, 'NavBar']);
  }

  /**
   * 获取是否展示红点
   */
  static getCreditRedDotShow(options) {
    return callNative.apply(this, ['getCreditRedDotShow', options]);
  }

  /**
   * 点击更新红点
   */
  static updateCreditUpdateTime(options) {
    return callNative.apply(this, ['updateCreditUpdateTime', options]);
  }

  /**
   * 新开一个webview展示H5
   * 顺风车提供
   */
  static openHitchWebview(param) {
    // 检查并处理 hiddenNavBar 参数
    if (param && param.url) {
      const hiddenNavBar = ParamsUtils.get('hiddenNavBar', param.url);
      const hiddenNavigationBar = ParamsUtils.get('hiddenNavigationBar', param.url);
      // 如果两个参数都存在但不相等，上报埋点（不做同步）
      if (hiddenNavBar && hiddenNavigationBar && hiddenNavBar !== hiddenNavigationBar) {
        try {
          TIANQI_UBT.customEventWithPointId({
            pointId: 'hitch_webview_params_mismatch',
            businessInfo: {
              url: param.url,
            },
          });
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log('埋点上报失败', e);
        }
      }
    }

    return callNative.apply(this, ['openHitchWebview', param]);
  }

  /**
   * 存储数据到app缓存
   * params.spKey 缓存的key
   * params.spValue 缓存的value
   */
  static setStorage(param) {
    return callNative.apply(this, ['setStorage', param]);
  }

  /**
   * 从app获取缓存数据
   * params.spKey 缓存的key
   * params.spValue 缓存不存在时返回的默认value
   */
  static getStorage(param) {
    return callNative.apply(this, ['getStorage', param]);
  }

  /**
   * 获取客户端已安装的地图导航软件
   */
  static getInstalledMapApps(param) {
    return callNative.apply(this, ['getInstalledMapApps', param]);
  }

  /**
   * 获取是否展示司南调研icon
   */
  static showGuideLIneIcon(options) {
    return callNative.apply(this, ['showGuideLIneIcon', options]);
  }

  /**
   * 获取是否展示司南调研icon
   */
  static openGuideLIneModal(options) {
    return callNative.apply(this, ['openGuideLIneModal', options]);
  }

  /**
  * 吊起支付，5.23.0加上
  * @param {string} 适用端口 - 哈啰出行APP
  * @param options
  * @returns {*}
  */
  static arousePayDeskModule(options) {
    return callNative.apply(this, ['arousePayDeskModule', options]);
  }

  // 刷新页面
  static refreshDriverHome(options) {
    return callNative.apply(this, ['refreshDriverHome', options]);
  }

  /**
   * 获取设备指纹hash
   * @param params
   */
  static getDeviceFingerprintHash(options) {
    return callNative.apply(this, ['getDeviceFingerprintHash', options]);
  }

  /**
   * 退出登录
   * @param params
   */
  static logout(options) {
    return callNative.apply(this, ['logout', options]);
  }

  /**
   * 显示loading
   * @param {loadingUrl: string} loadingUrl loading图片地址
   */
  static showLoading(options) {
    return callNative.apply(this, ['showLoading', options]);
  }

  /**
   * 隐藏loading
   * @param {delayTime: longint} delayTime 延迟隐藏毫秒数
   */
  static hideLoading(options = { delayTime: 500 }) {
    return callNative.apply(this, ['hideLoading', options]);
  }

  /**
   * 健康申明页面向Native传递业务数据
   */
  static healthStatementH5PostMessage({
    action,
    data,
  }) {
    return callNative.apply(this, ['sendEventToNative', {
      action,
      data,
    }, 'business/hitch']);
  }

  /**
   * 关闭app在wv中nav展示
   */
  static showTopNavigation(isShow) {
    return callNative.apply(this, ['showTopNavigation', { isShow }, 'MajiaBusiness']);
  }

  /**
   * 传token等登录信息给app
   */
  static saveUserInfo(options) {
    return callNative.apply(this, ['saveUserInfo', options, 'MajiaBusiness']);
  }

  /**
   * 通过app打开新的webview
   */
  static openNewWeb(url) {
    return callNative.apply(this, ['openNewWeb', { url }, 'MajiaBusiness']);
  }

  // 通过app埋点
  static trackEvent(options) {
    return callNative.apply(this, ['trackEvent', options, 'UBTBridge']);
  }

  /**
   * 拉起微信订阅消息
   */
  static openWechatService(options) {
    return callNative.apply(this, ['openWechatServiceNumber', options, 'business/hitch']);
  }

  // 顺风车增值服务取消订单通知App
  static orderCancelFinish(options) {
    return callNative.apply(this, ['orderCancelFinish', options, 'business/hitch']);
  }

  // 顺风车线下交易取消订单通知App
  static offlineOrderCancelFinish(options) {
    return callNative.apply(this, ['offlineOrderCancelFinish', options, 'business/hitch']);
  }

  /**
   * 安卓端悬浮窗相关方法
   */
  static showFloatWindowPermissionDialog(options) {
    return callNative.apply(this, ['showFloatWindowPermissionDialog', options, 'business/hitch']);
  }

  static checkFloatWindowPermission(options) {
    return callNative.apply(this, ['checkFloatWindowPermission', options, 'business/hitch']);
  }

  static checkFloatWindowEnable(options) {
    return callNative.apply(this, ['checkFloatWindowEnable', options, 'business/hitch']);
  }

  static updateFloatWindowStatus(options) {
    return callNative.apply(this, ['updateFloatWindowStatus', options, 'business/hitch']);
  }

  static logoutCurrentAccountAndLogin(options) {
    return callNative.apply(this, ['user_logoutCurrentAccountAndLogin', options, 'business/user']);
  }

  static openFloatWindowPermissionSetting(options) {
    return callNative.apply(this, ['openFloatWindowPermissionSetting', options, 'business/hitch']);
  }

  // 飞猪支付
  static miniPay(options) {
    return callNative.apply(this, ['miniPay', options]);
  }

  // 飞猪设置标题
  static setWebViewTitle(options) {
    return callNative.apply(this, ['setWebViewTitle', options]);
  }


  /**
  * @description 选择照片并上传
  */
  static chooseImageAndUploadImage(options) {
    return callNative.apply(this, ['chooseImageAndUploadImage', options, 'business/hitch']);
  }

  /**
   * @description 获取App未读消息数（无参，默认读取App当前登录用户）
   * @returns {Dictionary} {msgCount: 未读消息数}
   */
  static getIMChatUnreadMessageCount() {
    return callNative.apply(this, ['getIMChatUnreadMessageCount', null, 'business/hitch']);
  }

  static hitchNavigateTo(url) {
    return callNative.apply(this, ['hitchNavigateTo', { url }]);
  }

  static registerWebViewTCPBridge() {
    return callNative.apply(this, ['registerWebViewTCPBridge', null, 'business/phWebTcp']);
  }

  static unregisterWebViewTCPBridge() {
    return callNative.apply(this, ['unregisterWebViewTCPBridge', null, 'business/phWebTcp']);
  }

  /**
   * iOS跳转等待接单页（仅调用Native.closeWebView无法关闭iOS提供的套壳H5容器，需要iOS原生进行关闭操作）
   */
  static closePaxPKDetailPageAndNavigateToWaitingWithOrderGuid(options) {
    return callNative.apply(this, ['closePaxPKDetailPageAndNavigateToWaitingWithOrderGuid', options]);
  }

  /**
   * iOS跳转订单详情页（原因同上）
   */
  static closePaxPKDetailPageAndNavigateToJourneyDetailWithOrderGuid(options) {
    return callNative.apply(this, ['closePaxPKDetailPageAndNavigateToJourneyDetailWithOrderGuid', options]);
  }

  /**
   * 拉起iOS App收银台进行支付
   * （与平台提供的支付方法的区别在于，修复了平台收银台方法在H5销毁后，由于失去回调对象导致无法进行后续操作的问题）
   */
  static hitchArousePayDeskModule(options) {
    return callNative.apply(this, ['hitchArousePayDeskModule', options]);
  }

  /**
   * 从相机拍照
   */
  static takePhotoFromCamera(options) {
    return callNative.apply(this, ['takePhotoFromCamera', options]);
  }

  /**
   * 从相册选择照片
   */
  static pickPhotoFromGallery(options) {
    return callNative.apply(this, ['pickPhotoFromGallery', options]);
  }

  static async openHitchPassengerMpWebview(url) {
    const {
      mobile, ticket, token, userGuid,
    } = await this.getTokenAndKey();
    const webviewPath = `${env.isWeixin ? '/hitch/pages/MyWebView/MyWebView' : '/pages/MyWebView/MyWebView'}`;
    const H5Url = ParamsUtils.add(url, {
      token,
      mobile,
      userGuid,
      ticket,
    });
    const nextUrl = `${webviewPath}?url=${encodeURIComponent(H5Url)}`;
    if (env.isAlipayClient) {
      alipay.mpNavigateTo(nextUrl);
    } else if (env.isWeixin) {
      wechat.navigateTo(nextUrl);
    }
  }

  /**
   * 存储数据到app缓存
   */
  static setSpValue(options) {
    return callNative.apply(this, ['setSpValue', options]);
  }

  static jump2DouYinHitchDriverProfile(options) {
    return callNative.apply(this, ['jump2DouYinHitchDriverProfile', options]);
  }

  static createShortcutToDesktop(options) {
    return callNative.apply(this, ['createShortcutToDesktop', options]);
  }

  static jumpToPreOrderDetailPage(url) {
    return callNative.apply(this, ['jumpToPreOrderDetailPage', url]);
  }
}
